import { Layer } from '../../types'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { useMemo } from 'react'
import { useDeleteLayer } from '../../hooks/queries/layers/useDeleteLayer'
import { Button } from '../Button'
import Styles from './BottomMessage.module.scss'
import { ReactComponent as DeleteIcon } from '../../assets/icons/trash16.svg'
import { showToastMessage } from '../../common/ToastMessage/ShowToastMessage'
import { CleanupModeActionParam } from '../../stores/CleanupMode'
import { DocMode } from '../../stores/DocStore.types'
import { useDocStore } from '../../stores/DocStore'

interface Props {
  layer: Layer
}

export const DeleteLayerButton = ({ layer }: Props) => {
  const docStore = useDocStore()
  const history = useHistory()
  const { pathname, search } = useLocation()
  const searchParams = useMemo(() => new URLSearchParams(search), [search])

  const { mutate: deleteLayer, isLoading: isDeleting } = useDeleteLayer({ articleKey: layer.article_id, id: layer.id })

  const handleDeleteSuccess = () => {
    searchParams.delete(CleanupModeActionParam)
    if (!layer.parent_layer) {
      searchParams.delete('layer')
    } else {
      searchParams.set('layer', layer.parent_layer.id)
    }
    history.push({ pathname, search: searchParams.toString() })
    docStore.setDocMode(DocMode.Editor)
    showToastMessage(`${layer.name} is deleted.`)
  }

  const handleDelete = () => {
    deleteLayer(
      {
        onDelete: () => {
          handleDeleteSuccess()
        },
      },
      {
        onError: () => {
          showToastMessage('There was a problem deleting the layer, our team has been notified.', 'error')
        },
      },
    )
  }

  return (
    <Button
      className={Styles.leaveButton}
      size="md"
      frontIcon={DeleteIcon}
      isDisabled={isDeleting}
      onPress={() => handleDelete()}
      iconClassName={Styles.buttonIcon}
    >
      Delete Layer
    </Button>
  )
}
